
export enum StatementMethod {
  PAPER="01",
  WORD_DOC_EMAIL="02",
  EMS_WORD_DOC_EMAIL="03",
  EMS_FTP="25",
  EMS_EMAIL="30",
  EMAIL_NOTIFICATION_MC_ONLY="31",
  EMS_EMAIL_AND_PAPER_STATEMENT="32",
  DATA_FILE_MC_ONLY="33",
  NONE_MC_ONLY="34",
  PROP_SUM_EMS_STATEMENT_EMAIL="35",
  AGENCY_SUM_EMS_STATEMENT_EMAIL="36",
  EMS_WITH_TRANS_FEES_FTP="37",
  EMS_WITH_TRANS_FEES_EMAIL="38",
  EMS_WITH_COMM_REDUCED_FTP="39",
  EMS_WITH_COMM_REDUCED_EMAIL="40",
  TBG_EMAIL="41",
  TGB_FTP="42"
}